module.exports = __webpack_public_path__ + "img/album15_15.9303c053.jpg";